import { defineComponent, h } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import { QBtn } from 'quasar';

import TranslationContainer from './../TranslationContainer.jsx';

export default defineComponent({
    name: 'sform-button',
    mixins: [BaseComponent],
    components: {
        TranslationContainer,
        QBtn,
    },
    data: () => ({
        titleexpr: null,
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        title() {
            if(this.element.title)
                return <TranslationContainer context={this} value={this.element.title}></TranslationContainer>
            return null;
        },
    },
    methods: {
        click(e) {
            e.cancelBubble = true;
            e.stopPropagation();

            utils.executeAndCompileAllActions(this.element.Actions, { FormModel: this.cmodel, ParentModel: this.ParentModel }, this);
        }
    },
    render() {
        let input = (
            <QBtn
                outline
                no-caps
                class="q-mb-sm q-mr-sm c-SentenceCaseButton"
                size="12px"
                color="secondary"
                disable={!!this.appearance?.readonly}
                onClick={(e) => this.click(e)}
            >
                {this.title}
            </QBtn>
        );

        return input;
    }
});